import { BCMSStateManagerCRUD, useModel } from "@bcm-dev/bcms-vite";
import ChatPage, { getDefaultPageUI as getChatPageDefaultPageUI } from "components/pages/ChatPage";
import FullScreenChatPage, { getDefaultPageUI as getFullScreenChatPageDefaultPageUI } from "components/pages/FullScreenChatPage";
import ChatLandingPage from "components/pages/ChatLandingPage";

export default function CaptureChatMessageOpen(props) {
    const { branding } = useModel();
    const options = branding.options || {};

    const ui = BCMSStateManagerCRUD.init(getChatPageDefaultPageUI(options))
        .update([ "showInitialMessage" ], false)
        .update([ "showTranslationPopup" ], false)
        .submit();

    return <ChatLandingPage ui={ ui } />
}